import React from 'react'
import logo from '../Assets/logo.png'
import SideImage from '../Assets/download.png'

const NoteFoundPage = () => {
    return (
        <div className='NoteFoundPage-container'>
            <div className='side-image'>
                <img src={SideImage} alt="" />
            </div>
            <div className='details'>
                <h1>Work On Progress</h1>
                <div className='sub-details'>
                    <div>
                        <p><b>Marwari Software Tech</b></p>
                        <p>
                            We're hard at work building something amazing! Our website is currently under development, but we'll be launching soon. Stay tuned for updates as we bring you a cutting-edge digital experience. Thank you for your patience!
                        </p>

                    </div>
                    <img src={logo} alt="logo" />
                </div>
            </div>
        </div>
    )
}

export default NoteFoundPage
